import { useState, useRef, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import "./SignIn.scss";

import useOutsideClick from "hooks/useOutSideClick";

import { signInAtcion } from "store/actions/user";
import Button from "components/uiComponents/Button";

import btnImg from "static/images/btn_img.svg";
import { ReactComponent as LanguageIcon } from 'static/icons/language.svg'
import { ReactComponent as Triangle } from "static/icons/triangle.svg";

const SignIn = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const languageRef = useRef();

  const [isLanguageDropdownActive, setIsLanguageDropdownActive] = useState(false);

  const currentLanguage = useMemo(() => {
    switch (localStorage.getItem('language')) {
      case 'en': return "English"
      case 'he': return "עברית"
      default: return "English"
    }
  }, [localStorage.getItem('language')])

  useOutsideClick(languageRef, () => {
    setIsLanguageDropdownActive(false);
  });

  const handleLanguageChange = (language) => {
    i18n.changeLanguage(language);
    localStorage.setItem('language', language)
    window.location.reload();
  };

  const handleCLick = () => {
    dispatch(signInAtcion());
  };

  return (
    <div className="sing-in">
      <div className="form">
        <h1>
          {t('welcome')}
        </h1>
        <h3>
          <b>{t('to_start')}:</b> {t('connect_to_your_account')}<br />
          <b>{t('then')}:</b> {t('sign_in_to_bim')}
        </h3>
        <Button
          clickFunction={handleCLick}
          transparent
        >
          {t('sign_in_with')}
          <img
            src={btnImg}
            alt="Autodesk"
          />
        </Button>
        <h3 className="first-time-user">
          {t('first_time_user')} <a className="sign-up-guide" href="https://bim-search.com/2023/02/free-trial-sign-up-guide/" target="_blank">{t('sign_up_guide')}</a>
        </h3>
      </div>

      <div className="sing-in__language">
        <div className="sing-in__language-text">{t('change_language')}:</div>
        <div
          ref={languageRef}
          className="sing-in__language-curent-language-wrapper"
          onClick={() => setIsLanguageDropdownActive(prevState => !prevState)}
        >
          <LanguageIcon />
          <div className="sing-in__language-curent-language">{currentLanguage}</div>
          <Triangle />

          {isLanguageDropdownActive &&
            <div className="sing-in__language-dropdown">
              <div
                className="sing-in__language-dropdown__item"
                onClick={() => handleLanguageChange('en')}
              >
                English
              </div>
              <div
                className="sing-in__language-dropdown__item"
                onClick={() => handleLanguageChange('he')}
              >
                עברית
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default SignIn;
